<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 2.666c-2.577 0-4.666 2.25-4.666 5.026v8.615c0 2.776 2.09 5.026 4.667 5.026s4.666-2.25 4.666-5.026V7.692c0-2.776-2.089-5.026-4.666-5.026z" clip-rule="evenodd"/><path d="M12.334 28.333a1 1 0 011-1h5.333a1 1 0 110 2h-5.333a1 1 0 01-1-1zm11.333-13.667a1 1 0 00-1 1v1a6.665 6.665 0 01-9.218 6.16 6.668 6.668 0 01-4.115-6.16v-1a1 1 0 10-2 0v1a8.667 8.667 0 007.667 8.609v2.058h2v-2.058a8.665 8.665 0 007.666-8.609v-1a1 1 0 00-1-1z"/></svg>
</template>

<script>
export default {
  name: 'objectsMicrophoneFilled'
}
</script>
